import React, { Fragment } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { times } from '../../../../../play-core/utils/times';
import { loadTvLivestreamsNowAndNext, tvLivestreamNowAndNextIntervalInSeconds } from '../../../api/load-tv-livestream-with-now-and-next';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { SwimlaneTitle } from '../../../components/Swimlane/SwimlaneTitle';
import { LivestreamTeaser } from '../../../components/Teaser/LivestreamTeaser/LivestreamTeaser';
import { LivestreamTeaserPlaceholder } from '../../../components/Teaser/LivestreamTeaser/LivestreamTeaserPlaceholder';
import { queryKeys } from '../../../config/use-query';
import { useAxios } from '../../../hooks/use-axios';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TvLivestreams = () => {
  const {
    t
  } = useTranslation();
  const axios = useAxios();
  const {
    data: livestreams,
    error,
    isLoading
  } = useQuery({
    queryKey: [queryKeys.TvLivestreamsNowAndNext, axios],
    queryFn: () => loadTvLivestreamsNowAndNext(axios),
    refetchInterval: tvLivestreamNowAndNextIntervalInSeconds * 1000
  });
  const showElement = livestreams?.length !== 0 && !error;
  return /*#__PURE__*/_jsx(Fragment, {
    children: showElement && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
        title: t('home.watchTv')
      }), /*#__PURE__*/_jsx(PlayContainer, {
        children: /*#__PURE__*/_jsx(LivestreamLayout, {
          children: isLoading ? times(3, index => /*#__PURE__*/_jsx(LivestreamTeaserPlaceholder, {}, index)) : livestreams?.map((livestream, index) => /*#__PURE__*/_jsx(LivestreamTeaser, {
            livestreamNowAndNext: livestream,
            index: index
          }, livestream.id))
        })
      })]
    })
  });
};
const LivestreamLayout = styled.div.withConfig({
  displayName: "TvLivestreams__LivestreamLayout",
  componentId: "sc-1g3asyw-0"
})(["display:grid;grid-auto-columns:minmax(100px,400px);grid-auto-flow:column;grid-gap:16px;", "{grid-auto-flow:row;grid-auto-columns:minmax(100px,1fr);}"], Viewports.for('small'));